import React, { useEffect } from 'react';
import { Routes , Route, useLocation, Link } from 'react-router-dom';
import 'tw-elements'
import  'bootstrap-icons/font/bootstrap-icons.css';
import Admin from './pages/admin/Admin';


function App() {

  const location = useLocation();

  useEffect( () =>  {
        window.scroll(0,0)
  } , [ location ] )

  return (       
           <Routes> 
                 <Route path='/' element = { <div className='flex h-[100vh] justify-center items-center'>
                      <Link className='admin-form-btn' to={'/admin/create-company'}>
                            Click to view admin dashboard
                      </Link>
                 </div> } />
                 <Route path='/admin/*' element = { <Admin /> } />
           </Routes>       
         );
}

export default App;
